import { Input } from '@chakra-ui/react'
import { AxiosError } from 'axios'
import { useState, useEffect } from 'react'

import { FormField } from '../../../../components/FormField'
import { FormModal } from '../../../../components/FormModal'
import { useAppToast } from '../../../../helpers'
import { IKnowledgeAreaFormModalProps } from '../../../../interfaces/KnowledgeArea/KnowledgeArea'

export function KnowledgeAreaFormModal({ isOpen, onClose, editing, onSave }: IKnowledgeAreaFormModalProps) {
  const [name, setName] = useState('')
  const toast = useAppToast()
  const [error, setError] = useState('')

  useEffect(() => {
    setError('')
    if (editing) setName(editing.name)
    else setName('')
  }, [isOpen, editing])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!name.trim()) {
      toast.error('O nome é obrigatório')
      return
    }
    try {
      await onSave(name, editing?.id)
      onClose()
    } catch (err: unknown) {
      const error = err as AxiosError<{ message: string; errors?: Record<string, string[]> }>
      toast.error('Não foi possível salvar a área de conhecimento')
      if (error.response?.data?.errors?.name) {
        setError(error.response?.data?.errors?.name[0])
      }
    }
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={editing ? 'Editar Área de Conhecimento' : 'Adicionar Área de Conhecimento'}
      onSubmit={handleSubmit}
      size="compact"
    >
      <FormField label="Nome" error={error}>
        <Input value={name} onChange={(e) => setName(e.target.value)} autoFocus />
      </FormField>
    </FormModal>
  )
}
